import { setSelectedQuizzProfile } from "../reducers/quizzprofile"
import { store } from "../store/store"
import axios from "axios"

const { QUIZZ_PROFILE_API_ROUTE } = require("../../routes/api/api_routes")


const quizzprofile = {
    createQuizzProfile(data){
        return new Promise((resolve,reject)=>{

            const config = {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`JWT ${localStorage.getItem('access')}`,
                    'Accept':'application/json'
                }
              };

            axios.post(QUIZZ_PROFILE_API_ROUTE,data,config)
            .then(response => {
                if(response.status === 201){
                    let quizzprofile = response.data
                    let dispatch = store.dispatch
                    dispatch(setSelectedQuizzProfile(quizzprofile))
                    resolve(quizzprofile)
                }else{
                    reject(response)
                }
            })
            .catch(err => {
                console.log(err);
                reject(err)
            })
        })
    },
}
export default quizzprofile